import { create } from 'zustand';
import { Levels } from '../components/layout/Toast';

type errorType = {
  message: string;
  level: Levels;
};

interface ErrorState {
  errors: Array<errorType>;
  pushError: (error: errorType) => void;
  popError: () => void;
}

const useErrorStore = create<ErrorState>()((set) => ({
  errors: [],
  pushError: (error: errorType) => {
    set((state) => {
      return {
        ...state,
        errors: [...state.errors, error],
      };
    });
  },
  popError: () => {
    set((state) => {
      if (!state.errors.length) {
        return state;
      }

      return { ...state, errors: state.errors.slice(0, -1) };
    });
  },
}));

export default useErrorStore;
